import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { CountryEditorData } from "../../state/Countries/EditorData";


const updateCountriesEditorData: Reducer<CountryEditorData> = (state: CountryEditorData = new CountryEditorData(), action: Action<ActionType, CountryEditorData>) => {
  switch (action.type) {
    case ActionType.COUNTRIES_EDITOR_DATA_RESET:
      return new CountryEditorData();
    case ActionType.COUNTRIES_EDITOR_DATA_FETCHED:
      return { ...state, countryData: action.data };
    case ActionType.COUNTRIES_EDITOR_DATA_COPIED:
      return { ...state, countryData: { ...action.data} };
    case ActionType.COUNTRIES_EDITOR_DATA_UPDATED:
      return { ...state, countryData: { ...state.countryData, ...action.data } };
    case ActionType.COUNTRIES_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.COUNTRIES_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    default:
      return state;
  }
};

export default updateCountriesEditorData;